import { render, staticRenderFns } from "./actDetailList.vue?vue&type=template&id=2b35584a&scoped=true"
import script from "./actDetailList.vue?vue&type=script&lang=js"
export * from "./actDetailList.vue?vue&type=script&lang=js"
import style0 from "./actDetailList.vue?vue&type=style&index=0&id=2b35584a&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b35584a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/web-page/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2b35584a')) {
      api.createRecord('2b35584a', component.options)
    } else {
      api.reload('2b35584a', component.options)
    }
    module.hot.accept("./actDetailList.vue?vue&type=template&id=2b35584a&scoped=true", function () {
      api.rerender('2b35584a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "found/views/tpm/views/activity/marketing_activity/components/actDetailList.vue"
export default component.exports